import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CrewBonusStore } from './crew-bonus-store.service';

const ROLE_LABELS: Record<number, string> = { 1: 'Foreman', 2: 'Co-Foreman', 3: 'Installer' };

@Component({
  selector: 'app-crew-bonus-grid',
  templateUrl: './crew-bonus-grid.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule],
})
export class CrewBonusGridComponent {
  protected readonly store = inject(CrewBonusStore);

  readonly foremanUserId = input.required<string>();
  readonly selectedCrewUserIds = input.required<string[]>();

  protected rows() {
    return this.store.visibleRows(this.selectedCrewUserIds(), this.foremanUserId());
  }

  protected roleLabel(role: number | null): string {
    return role === null ? '—' : (ROLE_LABELS[role] ?? '—');
  }

  /**
   * `<input type="number">` with [ngModel] goes through Angular's NumberValueAccessor, which
   * already parses the raw DOM string and emits a number or null via ngModelChange — not the
   * string the DOM event carries. Passing it straight through avoids re-parsing a non-string.
   */
  protected onPercentChange(userId: string, value: number | null): void {
    this.store.setPercent(userId, value);
  }
}
